import React, { useEffect } from 'react';
import { Hero } from './components/Hero';
import { PainPoints } from './components/PainPoints';
import { Tomos } from './components/Tomos';
import { Bonos } from './components/Bonos';
import { Pricing } from './components/Pricing';
import { Guarantee } from './components/Guarantee';
import { Faq } from './components/Faq';
import { Testimonials } from './components/Testimonials';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
import { StickyCta } from './components/StickyCta';
import { initMetaPixel } from './utils/metaPixel';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="w-full bg-paper" data-id="element-0" data-mp="2wk09p15nonvi">
      <Hero data-id="element-1" data-mp="2wiyxuugtfxcq" />
      <main data-id="element-2" data-mp="2wj8e3qc26q58">
        <PainPoints data-id="element-3" data-mp="2wip6b2g4hi4x" />
        <Tomos data-id="element-4" data-mp="2wi5nljineppu" />
        <Bonos data-id="element-5" data-mp="28u5yeo0zj7dd" />
        <Pricing data-id="element-6" data-mp="28tw972nrl48q" />
        <Guarantee data-id="element-7" data-mp="28te3zgj4jfoo" />
        <Faq data-id="element-8" data-mp="28sl3gxardmez" />
        <Testimonials data-id="element-9" data-mp="28sbad0uf2z52" />
        <FinalCta data-id="element-10" data-mp="23vkvuhy9gblr" />
      </main>
      <Footer data-id="element-11" data-mp="23u9v6r043jyv" />
      <StickyCta data-id="element-12" data-mp="23utbk3a460as" />
    </div>;
}